import Vue from 'vue'
import Vuex from 'vuex'
import i18n from '@/i18n'
import Checkout from '@/api/checkout-api'
import Offer from '@/api/offer-api'
import OrderValidator from '@/api/order-validator'
import AuthApi from '@/api/auth-api'
import AccountApi from '@/api/account-api'
import contentApi from '../api/content-api'
import ValidationErrorHandler from '@/common/validation-error-handler'
import router from '../router'
import {NotificationProgrammatic as Notification} from 'buefy'
const accessTokenIndex = 'accessToken'
const referalIndex = 'referal'
import {bootstrap} from 'vue-gtag'

import {createLogger} from '@/common/log'
const logger = createLogger('store.js', '', false)

Vue.use(Vuex)

function analyticsDeactivated() {
  if (localStorage.acceptAllCookies === 'true') {
    return false
  }
  return true
}

// function getThemes(item) {
//   if (item.themes != undefined) {
//     return item.themes.map(f => f.name).join(',')
//   }

//   return ''
// }

export default new Vuex.Store({
  state: {
    cart: {},
    itemCount: 0,
    isGuardActive: false,
    disableSite: false,
    sidebarVisible: false,
    invalidPromotion: false,
    storeCurrency: 'EUR',
    isAnalyticsDeactivated: analyticsDeactivated(),
    menu: {
      themes: [],
      countries: [],
      footer: [],
    },
    content: {
      pending: true,
      home: [],
      pages: [],
    },
    promotions: [],
    isoCountries: [
      {iso: 'AT', country: i18n.t('countries.AT')},
      {iso: 'DE', country: i18n.t('countries.DE')},
      {iso: 'CH', country: i18n.t('countries.CH')},
      {iso: 'IT', country: i18n.t('countries.IT')},
      {iso: 'FR', country: i18n.t('countries.FR')},
      {iso: 'LI', country: i18n.t('countries.LI')},
      {iso: 'CZ', country: i18n.t('countries.CZ')},
    ],
    displayReduction: {
      hasActiveReduction: false,
      activeReductionName: null,
      reductionFx: null,
    },
    user: null,
    showLoginWindow: false,
    accessToken: {},
    locale: 'de',
  },
  getters: {
    productsInCart: state => state.cart.orderItems,
    currentOrderId: state => state.cart.id,
    currentOrderKey: state => state.cart.token,
    cartSubTotal: state =>
      state.cart.summary ? state.cart.summary.subtotal : 0,
    cartShipping: state =>
      state.cart.summary ? state.cart.summary.shippingTotal : 0,
    cartDiscount: state =>
      state.cart.summary ? state.cart.summary.discountTotal : 0,
    cartTotal: state => (state.cart.summary ? state.cart.summary.total : 0),
    cartFees: state => (state.cart.summary ? state.cart.summary.fees : []),
    cartPrepaid: state =>
      state.cart.summary ? state.cart.summary.prepaid : [],
    cartCurrency: state => state.cart.currency,
    cartPaymentType: state => state.cart.paymentType,
    activeReduction: state => state.cart.reduction,
    itemCount: state => state.itemCount,
    disableSite: state => state.disableSite,
    drawer: state => state.sidebarVisible,
    menu: state => state.menu,
    invalidPromotion: state => state.invalidPromotion,
    isoCountries: state => state.isoCountries,
    displayReduction: state => state.displayReduction,
    displayReductionActive: state => state.displayReduction.hasActiveReduction,
    isGuarded: state => state.isGuardActive,
    isAnalyticsDeactivated: state => state.isAnalyticsDeactivated,
    hasUser: state => state.user != null,
    userName: state => (state.user != null ? state.user.name : ''),
    token: state => state.accessToken,
    showLoginWindow: state => state.showLoginWindow,
    pages: state => state.content.pages,
    pendingContent: state => state.content.pending,
    home: state => state.content.home,
    locale: state => state.locale,
    promotions: state => state.promotions,
    localeIso: state => {
      if (state.locale === 'en') {
        return 'en_GB'
      }

      return `${state.locale}_${state.locale.toUpperCase()}`
    },
  },
  mutations: {
    CART_ITEMS_MODIFIED: (state, payload) => {
      state.cart.summary = payload.summary
    },
    PRODUCT_ADDED: (state, product) => {
      let replacingIndex = state.cart.orderItems.findIndex(
        f => f.id == product.id,
      )
      if (replacingIndex > -1) {
        state.cart.orderItems.splice(replacingIndex, 1, product)
      } else {
        state.cart.orderItems.push(product)
      }
      state.itemCount = state.cart.orderItems.reduce(
        (a, c) => a + c.quantity,
        0,
      )
      // try {
      //   if (Vue.prototype.$whitelabel.fbPixelEnabled) {
      //     Vue.analytics.fbq.event('AddToCart')
      //   }
      // } catch (e) {
      //   //todo some logging mechanism i guess
      // }
    },
    PRODUCT_REMOVED: (state, product) => {
      state.cart.orderItems = state.cart.orderItems.filter(
        f => f.id != product.id,
      )
      state.itemCount = state.cart.orderItems.reduce(
        (a, c) => a + c.quantity,
        0,
      )
    },
    PRODUCT_UPDATED: (state, product) => {
      let replacingIndex = state.cart.orderItems.findIndex(
        f => f.id == product.id,
      )
      state.cart.orderItems.splice(replacingIndex, 1, product)
      state.itemCount = state.cart.orderItems.reduce(
        (a, c) => a + c.quantity,
        0,
      )
    },
    CART_UPDATED: (state, cart) => {
      state.invalidPromotion = false
      state.cart = cart
      if (cart && cart.orderItems && cart.orderItems.length > 0) {
        state.itemCount = state.cart.orderItems.reduce(
          (a, c) => a + c.quantity,
          0,
        )
      } else {
        state.itemCount = 0
      }
    },
    PAYMENT_METHOD_UPDATED: (state, paymentMethod) => {
      state.cart.paymentType = paymentMethod
    },
    FLASH_MESSAGE_CREATED: (_, message) => {
      Notification.open(message)
    },
    REDUCTION_INFO_UPDATED: (state, reduction) => {
      if (!reduction || !reduction.valid) {
        state.displayReduction.hasActiveReduction = false
        state.displayReduction.reductionFx = null
        state.displayReduction.activeReductionName = null
      } else {
        state.displayReduction.hasActiveReduction = true
        //cap the value cause the cart / order system doesnt allow this anyways
        const capped = (val, org) => {
          if (val <= 0) {
            return org
          }
          return val
        }
        switch (reduction.operation) {
          case '+':
            state.displayReduction.reductionFx = amount =>
              capped(amount - reduction.value, amount)
            break
          case '%':
            state.displayReduction.reductionFx = amount =>
              capped(amount * (1 - reduction.value), amount)
            break
          default:
            state.displayReduction.reductionFx = amount => amount
            break
        }
        state.displayReduction.activeReductionName = reduction.name
      }
    },
    CART_CLEARED: state => {
      state.cart = {}
      state.itemCount = 0
    },
    INVALID_PROMOTION: state => {
      state.invalidPromotion = true
    },
    INVALID_PROMOTION_RESET: state => {
      state.invalidPromotion = false
    },
    SITE_LOCKED: state => {
      state.disableSite = true
    },
    SITE_UNLOCKED: state => {
      state.disableSite = false
    },
    DRAWER_CHANGED: (state, payload) => {
      state.sidebarVisible = payload.visible
    },
    MENU_LOADED: (state, payload) => {
      state.menu.countries = payload.countries
      state.menu.themes = payload.themes.filter(f => f.value)
    },
    CONTENT_RECEIVED: (state, payload) => {
      if (payload) {
        state.content.pages = payload.pages
        if (payload.extensionPoints) {
          for (let key of payload.extensionPoints.footerMenu) {
            let page = payload.pages.find(
              f => f.name == key && f.locale == state.locale,
            )
            if (page) {
              state.menu.footer.push({slug: page.slug, menu: page.title})
            }
          }
          if (payload.extensionPoints.home) {
            state.content.home = payload.extensionPoints.home
          }
        }
      }
      state.content.pending = false
    },
    TOGGLE_GUARD: (state, payload) => {
      state.isGuardActive = payload.active
    },
    DEACTIVATE_ANALYTICS: state => {
      state.isAnalyticsDeactivated = true
      localStorage.acceptAllCookies = false

      let analyticstype = Vue.prototype.$whitelabel.analyticsType

      if (analyticstype == 'gtag' || analyticstype == 'both') {
        logger.debug('gtag optout')
        //Vue.$gtag.enabled = false
        Vue.$gtag.optOut()
      }
      if (analyticstype == 'ua' || analyticstype == 'both') {
        logger.debug('ga optout')
        Vue.$ga.disable()
      }

      if (Vue.prototype.$whitelabel.tagManager) {
        logger.debug('gtm enabled:' + Vue.gtm.enabled())
        Vue.gtm.enable(false)
      }

      //#todo add gtag
    },
    ACTIVATE_ANALYTICS: state => {
      state.isAnalyticsDeactivated = false
      localStorage.acceptAllCookies = true

      let analyticstype = Vue.prototype.$whitelabel.analyticsType

      if (analyticstype == 'gtag' || analyticstype == 'both') {
        logger.debug('gtag optin')
        //Vue.$gtag.enabled = true
        bootstrap().then(() => {
          // all done!
          Vue.$gtag.optIn()
        })
      }

      if (analyticstype == 'ua' || analyticstype == 'both') {
        logger.debug('ga optin')
        Vue.$ga.enable()
      }

      if (Vue.prototype.$whitelabel.fbPixelEnabled) {
        Vue.analytics.fbq.init(Vue.prototype.$whitelabel.fbPixelId)
        Vue.analytics.fbq.event('PageView')
      }

      if (Vue.prototype.$whitelabel.tagManager) {
        logger.debug('gtm enabled:' + Vue.gtm.enabled())
        Vue.gtm.enable(true)
      }

      //#todo add gtag
    },
    ACCESS_TOKEN_UPDATED: (state, token) => {
      state.accessToken = token
      const jwt = AuthApi.parseJwt(token.token)
      if (state.user == null) {
        state.user = {}
      }
      state.user.id = jwt.id
      state.user.name = jwt.sub
    },
    ACCESS_TOKEN_DELETED: state => {
      state.accessToken = null
      state.user = null
    },
    TOGGLE_LOGIN_WINDOW: (state, payload) => {
      state.showLoginWindow = payload.show
    },
    LOCALE_CHANGED: (state, payload) => {
      state.locale = payload.locale
    },
    PROMOTIONS_RECEIVED: (state, payload) => {
      state.promotions = payload
    },
  },

  actions: {
    modifyCartProduct: (context, payload) => {
      if (payload.modified && payload.modified.length > 0) {
        for (let item of payload.modified) {
          context.commit('PRODUCT_UPDATED', item)
        }
      }
      if (payload.added && payload.added.length > 0) {
        for (let item of payload.added) {
          context.commit('PRODUCT_ADDED', item)
        }
      }
      if (payload.removed && payload.removed.length > 0) {
        for (let item of payload.removed) {
          context.commit('PRODUCT_REMOVED', item)
        }
      }
    },
    addProduct: async (context, variant) => {
      try {
        let order = await Checkout.createOrderIfNeeded()
        if (order) {
          context.commit('CART_UPDATED', order)
        }

        let res = await Checkout.addItem(variant)
        if (res) {
          context.commit('CART_ITEMS_MODIFIED', res)
          context.dispatch('modifyCartProduct', res)
        }
      } catch {
        context.commit('FLASH_MESSAGE_CREATED', {
          type: 'is-danger',
          position: 'is-bottom',
          message: i18n.t('errors.retryable-error'),
        })
      }
    },
    addGiftCard: async (context, tan) => {
      try {
        let order = await Checkout.createOrderIfNeeded()
        if (order) {
          context.commit('CART_UPDATED', order)
        }

        let res = await Checkout.addGiftCardToOrder(tan)
        if (res) {
          context.commit('CART_ITEMS_MODIFIED', {summary: res})
          context.dispatch('refreshPayment')
        }
      } catch {
        context.commit('FLASH_MESSAGE_CREATED', {
          type: 'is-danger',
          position: 'is-bottom',
          message: i18n.t('errors.retryable-error'),
        })
      }
    },
    removeGiftCard: async (context, tan) => {
      try {
        let res = await Checkout.removeGiftCardFromOrder(tan)
        if (res) {
          context.commit('CART_ITEMS_MODIFIED', {summary: res})
          context.dispatch('refreshPayment')
        }
      } catch {
        context.commit('FLASH_MESSAGE_CREATED', {
          type: 'is-danger',
          position: 'is-bottom',
          message: i18n.t('errors.retryable-error'),
        })
      }
    },
    removeProduct: async (context, item) => {
      try {
        let res = await Checkout.removeItem(item)
        if (res) {
          context.commit('CART_ITEMS_MODIFIED', res)
          context.dispatch('modifyCartProduct', res)
        }
      } catch {
        context.commit('FLASH_MESSAGE_CREATED', {
          type: 'is-danger',
          position: 'is-bottom',
          message: i18n.t('errors.retryable-error'),
        })
      }
    },
    changeQuantityOfProduct: async (context, payload) => {
      try {
        let res = await Checkout.changeQuantity(
          payload.itemId,
          payload.quantity,
        )
        if (res) {
          context.commit('CART_ITEMS_MODIFIED', res)
          context.dispatch('modifyCartProduct', res)
        }
      } catch {
        context.commit('FLASH_MESSAGE_CREATED', {
          type: 'is-danger',
          position: 'is-bottom',
          message: i18n.t('errors.retryable-error'),
        })
      }
    },
    refreshCart: async (context, payload) => {
      let res = await Checkout.checkOpenOrder()
      if (res) {
        context.commit('CART_UPDATED', res)
        if (payload && payload.delegateCustomer) {
          await context.dispatch(
            '$_checkout/useDelegatedUserData',
            res.customer,
          )
        }
        if (res.reductionId) {
          await context.dispatch('updateReductionInfo', res.reductionId)
        }
      }
    },
    refreshPayment: async context => {
      let res = await Checkout.refreshPaymentType()
      if (res) {
        context.commit('PAYMENT_METHOD_UPDATED', res)
      }
    },
    updatePayment: (context, payload) => {
      if (payload) {
        context.commit('PAYMENT_METHOD_UPDATED', payload)
      }
    },
    prepareForCheckout: async () => {
      await Checkout.prepareForCheckout()
      let validationResult = await OrderValidator.validateOrder()
      if (!validationResult.validForSale) {
        OrderValidator.invalidOrderHandler(validationResult)
      }
    },
    clearCart: context => {
      localStorage.removeItem('CURRENT_ID')
      localStorage.removeItem('TOKEN')
      context.commit('CART_CLEARED')
    },
    updateCart: (context, payload) => {
      context.commit('CART_UPDATED', payload)
    },
    lockSite: (context, payload) => {
      context.commit('SITE_LOCKED', payload)
    },
    unlockSite: context => {
      context.commit('SITE_UNLOCKED')
    },
    showDrawer: context => {
      context.commit('DRAWER_CHANGED', {visible: true})
    },
    hideDrawer: context => {
      context.commit('DRAWER_CHANGED', {visible: false})
    },
    setGuardActive: context => {
      context.commit('TOGGLE_GUARD', {active: true})
    },
    unlockGuard: context => {
      context.commit('TOGGLE_GUARD', {active: false})
    },
    loadMenuEntires: async context => {
      let data = await Offer.getMenu()
      context.commit('MENU_LOADED', data)
    },
    clearInvalidReduction: context => {
      context.commit('INVALID_PROMOTION_RESET')
    },
    flashMessageDanger: (context, payload) => {
      context.commit('FLASH_MESSAGE_CREATED', {
        type: 'is-danger',
        position: 'is-bottom',
        message: payload.message,
      })
    },
    applyReduction: async (context, code) => {
      try {
        await Checkout.createOrderIfNeeded()
        let res = await Checkout.applyReduction(code)
        context.commit('CART_UPDATED', res)
        if (res.reductionId) {
          context.dispatch('updateReductionInfo', res.reductionId)
        }
      } catch (error) {
        if (error && error.response) {
          if (error.response.type == 'https://httpstatuses.com/500') {
            //notify
          }
          if (
            error.status == 417 ||
            error.response.data.type ==
              'https://touristik-vertrieb.at/invalid-reduction'
          ) {
            context.commit('INVALID_PROMOTION')
          }
        }
        context.dispatch('unlockSite')
      }
    },
    removeReduction: async context => {
      await Checkout.createOrderIfNeeded()
      let res = await Checkout.removeReduction()
      context.commit('CART_UPDATED', res)
    },
    updateReductionInfo: async (context, id) => {
      let res = await Checkout.getReductionInfo(id)
      context.commit('REDUCTION_INFO_UPDATED', res)
    },
    deactivateAnalytics: context => {
      context.commit('DEACTIVATE_ANALYTICS')
    },
    activateAnalytics: context => {
      context.commit('ACTIVATE_ANALYTICS')
    },
    login: async ({dispatch, commit}, payload) => {
      try {
        let res = await AuthApi.login(payload.usr, payload.pwd)
        if (res && res.accessToken) {
          var expiresOn = new Date()
          const expiry = expiresOn.setSeconds(
            expiresOn.getSeconds() + res.accessToken.expiresIn,
          )
          res.accessToken.expiry = expiry
          localStorage.setItem(
            accessTokenIndex,
            JSON.stringify(res.accessToken),
          )
          commit('ACCESS_TOKEN_UPDATED', res.accessToken)
          if (
            res.orderId &&
            res.orderId.length > 0 &&
            res.token &&
            res.token.length > 0
          ) {
            Checkout.updateCurrentOrder(res.orderId, res.token)
            await dispatch('refreshCart')
          }
          commit('TOGGLE_LOGIN_WINDOW', {show: false})
        }
        return res
      } catch {
        return {
          success: false,
        }
      }
    },
    logout: async ({commit}) => {
      commit('ACCESS_TOKEN_DELETED')
      localStorage.removeItem(accessTokenIndex)
      Checkout.resetOrderStorage()
      commit('CART_CLEARED')
      router.push({name: 'account'})
    },
    storeInit: async ({commit}, payload) => {
      if (payload.locale) {
        commit('LOCALE_CHANGED', {locale: payload.locale})
      }
      let content = await contentApi.getOverview(payload.site)
      commit('CONTENT_RECEIVED', content)
      let promotions = await contentApi.getCurrentPromotions()
      commit('PROMOTIONS_RECEIVED', promotions)
    },
    setReferalToken: (_, payload) => {
      const stored = localStorage.getItem(referalIndex)
      if (stored) {
        const referal = JSON.parse(stored)
        if (payload.code === referal.code) {
          return
        }
      }
      const newReferal = JSON.stringify(payload)
      localStorage.setItem(referalIndex, newReferal)
    },
    loadAccesToken: ({commit}) => {
      const storageToken = localStorage.getItem(accessTokenIndex)
      if (storageToken) {
        const token = JSON.parse(storageToken)
        if (new Date(token.expiry) > new Date()) {
          commit('ACCESS_TOKEN_UPDATED', JSON.parse(storageToken))
        }
      }
    },
    refreshToken: async ({commit}) => {
      try {
        let res = await AuthApi.refresh(commit.token)
        if (res && res.accessToken) {
          var expiresOn = new Date()
          let expiry = expiresOn.setSeconds(
            expiresOn.getSeconds() + res.accessToken.expiresIn,
          )
          res.accessToken.expiry = expiry
          localStorage.setItem(
            accessTokenIndex,
            JSON.stringify(res.accessToken),
          )
          commit('ACCESS_TOKEN_UPDATED', res.accessToken)
        }
      } catch {
        //if we cant extend it - we throw it away
        commit('ACCESS_TOKEN_DELETED')
      }
    },
    showLogin: async ({commit}) => {
      commit('TOGGLE_LOGIN_WINDOW', {show: true})
    },
    passwordForgotten: async (context, payload) => {
      try {
        let result = await AccountApi.passwordForgotten(payload.email)
        return result
      } catch (e) {
        let validationError = ValidationErrorHandler.handle(e)
        if (validationError.handled) {
          return {success: false, errors: validationError.errors}
        }
        let success = {success: false, errors: []}
        return success
      }
    },
    changeLocale: (context, payload) => {
      context.commit('LOCALE_CHANGED', payload)
      context.dispatch('loadMenuEntires')
    },
  },
})
